import { Component, OnInit } from '@angular/core';
import { CompanyDetail, CompanyInstallationsDetail, CompanyPersonsDetail, } from 'src/app/model/company/company';
import { CompaniesService } from 'src/app/services/http/companies/companies.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit {


  constructor(private service: CompaniesService) { }

  detail !: CompanyDetail;
  personnes !: CompanyPersonsDetail;
  installations !: CompanyInstallationsDetail;

  ngOnInit(): void {
    let id = '42';
    console.error( ' loading hardcoded id ' + id)
    this.service.getCompany( id ).subscribe((detail) => {
      // console.log(companies.societes[0].id_societe);
      console.log(detail)
      this.detail = detail;
    });

    
    console.error( ' loading hardcoded id ' + id)
    this.service.getCompanyPersonsDetailData( id ).subscribe((personnes) => {
      // console.log(companies.societes[0].id_societe);
      console.log(personnes)
      this.personnes = personnes;
    });

    console.error( ' loading hardcoded id ' + id)
    this.service.getCompanyInstallationsDetailData( id ).subscribe((installations) => {
      // console.log(companies.societes[0].id_societe);
      console.log(installations)
      this.installations = installations;
    });



  }


  sortby(column: string): void{
    console.log('Tri par la colonne '+ column);
  }
  

}
